module.exports = __webpack_public_path__ + "img/night-top-bg_en.61eced6f.png";